import React from 'react';
import classnames from 'classnames/bind';
import { EmptyContent } from './components/EmptyContent/EmptyContent';
import { Event } from './components/Event/Event';
import { useHighlightKeys } from './hooks/useHighlightKeys';
import styles from './eventsContent.module.scss';

const classNameBuilder = classnames.bind(styles);

export const EventsContent = ({ pixelTesterEvents, isOnBoarding }) => {
    const highlightedKeys = useHighlightKeys(pixelTesterEvents, event => event._key);
    const hasNoEvents = !pixelTesterEvents?.length;

    return (
        <div className={classNameBuilder('container', { 'full-height': hasNoEvents })}>
            {hasNoEvents ? (
                <EmptyContent isOnBoarding={isOnBoarding} />
            ) : (
                pixelTesterEvents.map(eventData => (
                    <Event
                        key={eventData._key}
                        eventData={eventData}
                        highlightedKeys={highlightedKeys}
                        isOnBoarding={isOnBoarding}
                    />
                ))
            )}
        </div>
    );
};
